import { useEffect, useState } from 'react'

export default function useCountdown(nextGameStart: number, interval: number = 1000) {
  const [countdownTime, setcountdownTime] = useState(0)

  useEffect(() => {
    const timerInterval = setInterval(() => {
      const currentTime = Date.now()
      const newCountdownTime = nextGameStart - currentTime
      if (newCountdownTime <= 0) {
        clearInterval(timerInterval)
      }
      setcountdownTime(newCountdownTime)
    }, interval)

    return () => {
      clearInterval(timerInterval)
    }
  }, [interval, nextGameStart])

  return countdownTime
}
